import {
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  Line,
  Tooltip,
  ComposedChart,
} from "recharts";

import {
  selectFormat,
  Metric,
  MiniMetric,
  Error,
  MAIN_COLORS,
} from "./../Utils/Utils.js";

import Heading from "./../Elements/Heading";

function SummaryPerformance({ data }) {
  if (!data) {
    return <Error minHeight={360} />;
  }

  const CustomTooltip = ({ active, payload }) => {
    if (!active || !payload?.length) return null;

    const data = payload[0].payload;
    return (
      <div className="standard-tooltip">
        <header className="standard-tooltip__header">
          <span className="standard-tooltip__key-header">Month:</span>
          <span className="standard-tooltip__value-header">
            {data.fullName}
          </span>
        </header>
        <main className="standard-tooltip__main">
          {data.Monthly > 0 && (
            <div className="standard-tooltip__item">
              <span className="standard-tooltip__key">
                <span
                  className="standard-tooltip__icon"
                  style={{ background: MAIN_COLORS[0] }}
                />
                Monthly
              </span>
              <span className="standard-tooltip__value">
                {selectFormat("number", data.Monthly)}
              </span>
            </div>
          )}
          {data.Annual > 0 && (
            <div className="standard-tooltip__item">
              <span className="standard-tooltip__key">
                <span
                  className="standard-tooltip__icon"
                  style={{ background: MAIN_COLORS[1] }}
                />
                Annual
              </span>
              <span className="standard-tooltip__value">
                {selectFormat("number", data.Annual)}
              </span>
            </div>
          )}
          {data.year2024 > 0 && (
            <div className="standard-tooltip__item">
              <span className="standard-tooltip__key">
                <span
                  className="standard-tooltip__icon"
                  style={{ background: MAIN_COLORS[4] }}
                />
                2024 Target
              </span>
              <span className="standard-tooltip__value">
                {selectFormat("number", data.year2024)}
              </span>
            </div>
          )}
          {data.year2023 > 0 && (
            <div className="standard-tooltip__item">
              <span className="standard-tooltip__key">
                <span
                  className="standard-tooltip__icon"
                  style={{ background: MAIN_COLORS[3] }}
                />
                2023 Year
              </span>
              <span className="standard-tooltip__value">
                {selectFormat("number", data.year2023)}
              </span>
            </div>
          )}
        </main>
      </div>
    );
  };

  return (
    <div className="row align-items-center">
      <div className="col-sm-12 col-md-6">
        <Heading size={6} className="mb-1">
          Total Paying Subs (As of Yesterday)
        </Heading>
        <div className="d-flex">
          <Metric {...data.totalSubs} graph={data.totalSubs.graph} size="lg" />
          {data.byChannel && (
            <div className="ml-4 d-flex flex-column align-self-center">
              <MiniMetric
                {...data.byChannel.YES}
                icon="yes"
                iconType="custom"
              />
              <MiniMetric
                {...data.byChannel.MSG}
                icon="msg"
                iconType="custom"
              />
              <MiniMetric
                {...data.byChannel.BUNDLE}
                icon="gotham"
                iconType="custom"
              />
            </div>
          )}
        </div>
      </div>

      <div className="col-sm-12 col-md-6">
        <div className="row">
          <div className="col-12">
            <ResponsiveContainer height={100} width="100%">
              <ComposedChart
                data={data.dataByMonth}
                margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
              >
                <YAxis hide />
                <Tooltip
                  content={<CustomTooltip />}
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                />

                <Bar
                  dataKey="Monthly"
                  stackId="subscriptions"
                  fillOpacity={1}
                  fill={MAIN_COLORS[0]}
                />
                <Bar
                  dataKey="Annual"
                  stackId="subscriptions"
                  fillOpacity={1}
                  fill={MAIN_COLORS[1]}
                />

                <Line
                  type="monotone"
                  dataKey="year2024"
                  stroke={MAIN_COLORS[4]}
                  strokeWidth={2}
                  strokeDasharray="2 3"
                  dot={false}
                  isAnimationActive={false}
                />

                {data.dataByMonth.some((item) => item.year2023 > 0) && (
                  <Line
                    type="monotone"
                    dataKey="year2023"
                    stroke={MAIN_COLORS[3]}
                    strokeWidth={2}
                    strokeDasharray="2 3"
                    dot={false}
                    isAnimationActive={false}
                  />
                )}

                <XAxis
                  dataKey="name"
                  axisLine={false}
                  tickLine={false}
                  tick={{ strokeWidth: 0, fill: "#25263F" }}
                />
              </ComposedChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SummaryPerformance;
